/* eslint-disable max-len */

/**
 * @author: Richard Scoones @ 20/03/2018
 * @description: Custom simple spinner. Intended to be used inline with input fields
 */
import React, {FC} from "react"

import BaseSvgIcon from "../../Icon/customIcons/Base"

export interface Props {
  color?: string
}

const TinyLoader: FC<Props> = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <g>
        <ellipse transform="rotate(0, 7, 2)" cx="7" cy="2" rx="2" ry="2" style={{opacity: 0.3}}>
          <animate attributeType="CSS" attributeName="opacity" from="1" to="0" dur="0.6s" repeatCount="indefinite" begin="0s" />
        </ellipse>
        <ellipse transform="rotate(60, 11.3301, 4.5)" cx="11.3301" cy="4.5" rx="2" ry="2" style={{opacity: 0.3}}>
          <animate attributeType="CSS" attributeName="opacity" from="1" to="0" dur="0.6s" repeatCount="indefinite" begin="0.1s" />
        </ellipse>
        <ellipse transform="rotate(120, 11.3301, 9.5)" cx="11.3301" cy="9.5" rx="2" ry="2" style={{opacity: 0.3}}>
          <animate attributeType="CSS" attributeName="opacity" from="1" to="0" dur="0.6s" repeatCount="indefinite" begin="0.2s" />
        </ellipse>
        <ellipse transform="rotate(180, 7, 12)" cx="7" cy="12" rx="2" ry="2" style={{opacity: 0.3}}>
          <animate attributeType="CSS" attributeName="opacity" from="1" to="0" dur="0.6s" repeatCount="indefinite" begin="0.3s" />
        </ellipse>
        <ellipse transform="rotate(240, 2.6699, 9.5)" cx="2.6699" cy="9.5" rx="2" ry="2" style={{opacity: 0.3}}>
          <animate attributeType="CSS" attributeName="opacity" from="1" to="0" dur="0.6s" repeatCount="indefinite" begin="0.4s" />
        </ellipse>
        <ellipse transform="rotate(300, 2.6699, 4.5)" cx="2.6699" cy="4.5" rx="2" ry="2" style={{opacity: 0.3}}>
          <animate attributeType="CSS" attributeName="opacity" from="1" to="0" dur="0.6s" repeatCount="indefinite" begin="0.5s" />
        </ellipse>
      </g>
    </BaseSvgIcon>
  )
}

export default TinyLoader
